import React, { useState, useEffect } from "react"
import styled from "styled-components/macro"
import Product from "./Product"
import { serverAPI } from "../services/apiParams"
import Typography from "@mui/material/Typography"

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
`

const Products = ({ cat, sort }) => {
  const [products, setProducts] = useState([])
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    const getProducts = async () => {
      try {
        const res = await serverAPI.get(
          cat ? `api/products/?category=${cat}` : "api/products"
        )
        if (res.data.products.length === 0) {
          setErrorMessage("No products found")
        }
        setProducts(res.data.products)
      } catch (error) {
        setErrorMessage(error?.response?.data?.error)
      }
    }
    getProducts()
  }, [cat])

  useEffect(() => {
    if (sort === "newest") {
      setProducts((prev) => {
        return [...prev].sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at)
        })
      })
    } else if (sort === "asc") {
      setProducts((prev) => {
        return [...prev].sort((a, b) => {
          return b.price - a.price
        })
      })
    } else {
      setProducts((prev) => {
        return [...prev].sort((a, b) => a.price - b.price)
      })
    }
  }, [sort])

  if (errorMessage?.length > 0)
    return (
      <Typography variant='h3' align='center' gutterBottom={true}>
        {errorMessage}
      </Typography>
    )
  if (products.length < 1)
    return (
      <Typography variant='h3' align='center' gutterBottom={true}>
        Products Loading...
      </Typography>
    )

  return (
    <Container>
      {products.slice(0, 8).map((item) => (
        <Product item={item} key={item.id} />
      ))}
    </Container>
  )
}

export default Products
